import {
  Box,
  Button,
  MenuItem,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SearchBar from "../../components/SearchBar";
import React from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ManageRevenue = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [rows] = useState([
    {
      id: 1,
      userName: "John Doe",
      email: "john@example.com",
      phone: "9876543210",
      packageName: "Gold",
      amount: "€94.99",
      paymentDate: "01-Sept-2025",
      paymentMode: "Online",
      paymentStatus: "Paid",
      paymentMethod: "Credit Card",
    },
    {
      id: 2,
      userName: "Sarah Smith",
      email: "sarah@example.com",
      phone: "9876501234",
      packageName: "Platinum",
      amount: "€144.99",
      paymentDate: "03-Sept-2025",
      paymentMode: "Offline",
      paymentStatus: "Pending",
      paymentMethod: "Cash",
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Revenue Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Revenue Management
        </p>
      </div>

      {/* STATS */}
      <div className="stats_boxes v3 gap_m mb_20">
        <div className="cards w_33">
          <figure><AttachMoneyIcon /></figure>
          <h2>$128,450</h2>
          <p>Total Revenue</p>
        </div>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1">
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className="custom_tabs_links">
              <Tab label="Package Revenue" {...a11yProps(0)} />
              <Tab label="VAT" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={value} index={0}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>User Detail</TableCell>
                  <TableCell>Package Name</TableCell>
                  <TableCell>Amount Received</TableCell>
                  <TableCell>Payment Received On</TableCell>
                  <TableCell>Payment Mode</TableCell>
                  <TableCell>Payment Status</TableCell>
                  <TableCell>Payment Method</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{index + 1}</TableCell>

                    <TableCell>
                      <div className="user_block">
                        <figure>
                          <img
                            src="/static/images/user_placeholder.png"
                            alt="User"
                          />
                        </figure>
                        <p>
                          <b>{row.userName}</b>
                          {row.email}<br />
                          {row.phone}
                        </p>
                      </div>
                    </TableCell>

                    <TableCell>{row.packageName}</TableCell>
                    <TableCell>{row.amount}</TableCell>
                    <TableCell>{row.paymentDate}</TableCell>
                    <TableCell>{row.paymentMode}</TableCell>

                    <TableCell>
                      <span
                        className={`status_btn dark ${row.paymentStatus === "Paid" ? "c_success" : "c_warning"
                          }`}
                      >
                        {row.paymentStatus}
                      </span>
                    </TableCell>

                    <TableCell>{row.paymentMethod}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <form className="form" action="">
            <div className="gap_p">
              <div className="control_group w_33">
                <label htmlFor="type">Set VAT Type</label>
                <Select fullWidth hiddenLabel defaultValue="default">
                  <MenuItem value="default" disabled>Select VAT Type</MenuItem>
                  <MenuItem value="1">Flat</MenuItem>
                  <MenuItem value="2">Percentage</MenuItem>
                </Select>
              </div>
              <div className="control_group w_33">
                <label htmlFor="type">Set VAT</label>
                <TextField fullWidth hiddenLabel placeholder="Set VAT"></TextField>
              </div>
            </div>

            {/* SAVE BUTTON */}
            <div className="form_btn">
              <Button className="btn btn_primary">Save</Button>
            </div>
          </form>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageRevenue;